const handleCheckGeneral = newsLetterState => {
  const [_, ...optionsArray] = Object.values(newsLetterState)

  if (optionsArray.every(value => value)) {
    return {
      ...newsLetterState,
      general: 'checked'
    }
  }

  if (optionsArray.every(value => !value)) {
    return {
      ...newsLetterState,
      general: 'unchecked'
    }
  }

  return newsLetterState
}

export const generalNewsletterToggle = newsletterOptions => {
  const isChecked = newsletterOptions.general === 'checked'

  return {
    general: isChecked ? 'unchecked' : 'checked',
    email: !isChecked,
    sms: !isChecked,
    whatsapp: !isChecked
  }
}

export const newsletterEmailToggle = newsletterOptions => {
  const isChecked = newsletterOptions.email

  const emailValues = {
    ...newsletterOptions,
    general: 'indeterminate',
    email: !isChecked
  }

  return handleCheckGeneral(emailValues)
}

export const newsletterSmsToggle = newsletterOptions => {
  const isChecked = newsletterOptions.sms

  const smsValues = {
    ...newsletterOptions,
    general: 'indeterminate',
    sms: !isChecked
  }

  return handleCheckGeneral(smsValues)
}

export const newsletterWhatsAppToggle = newsletterOptions => {
  const isChecked = newsletterOptions.whatsapp

  const whatsAppValues = {
    ...newsletterOptions,
    general: 'indeterminate',
    whatsapp: !isChecked
  }

  return handleCheckGeneral(whatsAppValues)
}
